var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 20,
    viewBox: "0 0 61 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.9999 10.3134C60.9999 7.10423 58.8987 4.572 54.8829 4.572C50.8501 4.572 48.4101 7.10423 48.4101 10.2883C48.4101 14.0616 51.2907 15.9671 55.4251 15.9671C57.4415 15.9671 58.9665 15.6286 60.1187 15.1522V12.6451C58.9665 13.0713 57.6449 13.3345 55.9674 13.3345C54.3237 13.3345 52.8665 12.9083 52.6801 11.4291H60.966C60.966 11.2661 60.9999 10.6143 60.9999 10.3134ZM52.6293 9.1225C52.6293 7.70595 53.7985 7.11677 54.866 7.11677C55.8996 7.11677 57.001 7.70595 57.001 9.1225H52.6293Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8699 4.572C40.2093 4.572 39.1418 5.14865 38.5488 5.5498L38.3285 4.77257H34.6007V19.3895L38.8368 18.7251L38.8538 15.1774C39.4638 15.5033 40.3618 15.9672 41.8529 15.9672C44.886 15.9672 47.6479 14.162 47.6479 10.1881C47.631 6.55268 44.8352 4.572 41.8699 4.572ZM40.8532 13.2093C39.8535 13.2093 39.2604 12.946 38.8538 12.6201L38.8368 7.96924C39.2774 7.60569 39.8874 7.35498 40.8532 7.35498C42.3951 7.35498 43.4627 8.63364 43.4627 10.2758C43.4627 11.9557 42.4121 13.2093 40.8532 13.2093Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7718 3.83233L33.0249 3.15534V0.610352L28.7718 1.27481V3.83233Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0249 4.78496H28.7718V15.754H33.0249V4.78496Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2138 5.71218L23.9427 4.78451H20.2827V15.7536H24.5188V8.3197C25.5185 7.35442 27.213 7.52992 27.7383 7.66782V4.78451C27.196 4.63408 25.2135 4.35828 24.2138 5.71218Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7416 2.0644L11.6072 2.7163L11.5902 12.758C11.5902 14.6134 13.471 15.9798 15.9788 15.9798C17.3683 15.9798 18.3849 15.7918 18.9441 15.5661V13.0212C18.4019 13.1842 15.7247 13.7609 15.7247 11.9055V7.45506H18.9441V4.78481H15.7247L15.7416 2.0644Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28695 7.96927C4.28695 7.48036 4.82917 7.29232 5.72723 7.29232C7.01501 7.29232 8.64168 7.58065 9.92946 8.09463V5.14866C8.52307 4.73497 7.13362 4.572 5.72723 4.572C2.2875 4.572 0 5.90082 0 8.1197C0 11.5796 6.4389 11.0281 6.4389 12.5199C6.4389 13.0965 5.76112 13.2846 4.81223 13.2846C3.40584 13.2846 1.60972 12.8583 0.186389 12.2817V15.2652C1.76222 15.7667 3.355 15.9798 4.81223 15.9798C8.33668 15.9798 10.7597 14.6886 10.7597 12.4446C10.7428 8.70889 4.28695 9.3733 4.28695 7.96927Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStripe);
export default __webpack_public_path__ + "static/media/icon-stripe.9ac0cb47f6a4b6cde343d940b32d1f35.svg";
export { ForwardRef as ReactComponent };